/**
 * Logo Gallery Block - Frontend JavaScript
 * Enables horizontal drag-to-scroll functionality
 */

document.addEventListener('DOMContentLoaded', () => {
	const galleries = document.querySelectorAll('.commcore26-logo-gallery__images');

	galleries.forEach((gallery) => {
		let isDown = false;
		let startX;
		let scrollLeft;

		// Prevent default image drag
		gallery.addEventListener('dragstart', (e) => {
			e.preventDefault();
		});

		gallery.addEventListener('mousedown', (e) => {
			isDown = true;
			gallery.classList.add('is-dragging');
			startX = e.pageX - gallery.offsetLeft;
			scrollLeft = gallery.scrollLeft;
		});

		gallery.addEventListener('mouseleave', () => {
			isDown = false;
			gallery.classList.remove('is-dragging');
		});

		gallery.addEventListener('mouseup', () => {
			isDown = false;
			gallery.classList.remove('is-dragging');
		});

		gallery.addEventListener('mousemove', (e) => {
			if (!isDown) return;
			e.preventDefault();
			const x = e.pageX - gallery.offsetLeft;
			const walk = (x - startX) * 2; // Scroll speed multiplier
			gallery.scrollLeft = scrollLeft - walk;
		});
	});
});
